(() => {
  const tag = 'inventa-product-recommendations';
  if (customElements.get(tag)) return;

  class InventaProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.lifecycle && !this.lifecycle.signal.aborted) return;
      this.lifecycle = new AbortController();
      window.addEventListener('pagehide', () => this.cancelRequest(), {signal: this.lifecycle.signal});
      window.addEventListener('pageshow', event => {
        if (event.persisted) this.load();
      }, {signal: this.lifecycle.signal});
      this.load();
    }

    disconnectedCallback() {
      this.lifecycle?.abort();
      this.cancelRequest();
    }

    cancelRequest() {
      this.generation = (this.generation || 0) + 1;
      this.request?.abort();
      this.request = null;
      this.removeAttribute('aria-busy');
    }

    setVisible(visible) {
      this.hidden = !visible;
      const wrapper = this.closest('.shopify-section');
      if (wrapper) wrapper.hidden = !visible;
    }

    async load() {
      if (!this.isConnected) return;
      this.cancelRequest();
      this.setVisible(false);
      const {sectionId, productId, limit, intent = 'related'} = this.dataset;
      if (!sectionId || !/^[1-9]\d*$/.test(productId || '') ||
          !Number.isInteger(Number(limit)) || Number(limit) < 1 || Number(limit) > 10 || intent !== 'related') return;

      const request = new AbortController();
      const generation = this.generation;
      this.request = request;
      const isCurrent = () => this.isConnected && this.generation === generation && !request.signal.aborted;
      this.setAttribute('aria-busy', 'true');

      try {
        const root = window.Shopify?.routes?.root || '/';
        const url = new URL(`${root}recommendations/products`, location.origin);
        url.searchParams.set('product_id', productId);
        url.searchParams.set('limit', limit);
        url.searchParams.set('section_id', sectionId);
        url.searchParams.set('intent', intent);
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);

        const response = await fetch(url, {signal: request.signal, credentials: 'same-origin', cache: 'no-store'});
        if (!isCurrent() || !response.ok) return;
        const html = await response.text();
        if (!isCurrent()) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const source = Array.from(parsed.querySelectorAll(tag)).find(element => element.dataset.sectionId === sectionId);
        const grid = source?.querySelector('[data-inventa-product-grid]');
        if (!grid?.querySelector('[data-inventa-product-card]')) return;

        // Keep this host and its lifecycle; only Shopify's matching section content is replaced.
        this.replaceChildren(...Array.from(source.childNodes, node => document.importNode(node, true)));
        this.setVisible(true);
        document.dispatchEvent(new Event('inventa:wishlist-buttons-added'));
      } catch {
        // An old rejection must never hide the result of a newer request.
        if (isCurrent()) this.setVisible(false);
      } finally {
        if (isCurrent()) {
          this.request = null;
          this.removeAttribute('aria-busy');
        }
      }
    }
  }

  customElements.define(tag, InventaProductRecommendations);
})();
